import type {ManifestationStatus} from 'api/types';
import {getManifestationStatusColor} from '../functions';

export const useManifestationStatusColor = (
  status: ManifestationStatus,
): string => getManifestationStatusColor(status);
